/**
 * Environment detection helper for AdminWeb.
 */
export const isTestEnvironment = (): boolean => {
  if (process.env.REACT_APP_IS_TEST_ENV === 'true') {
    return true;
  }
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname.toLowerCase();
    if (host.startsWith('test.')) {
      return true;
    }
  }
  const apiUrl = process.env.REACT_APP_API_BASE_URL || '';
  return /\/\/test\./i.test(apiUrl);
};
